import https from "./https-common";

const getAllBadge = (shopDomain) => {
  let shop = shopDomain.replace(".myshopify.com", "");
  shop = shop.replace("https://", "");
  return https.get(`/badges?shop=${shop}`);
};

const updateBadge = (id, data) => {
  return https.put(`/badges/${id}`, data);
};

const BadgeService = {
  getAllBadge,
  updateBadge,
};

export default BadgeService;
